import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';
import LogoIncoop from '../../assets/images/logos/logo_incoop.svg';
import { useAuth } from '../context/AuthContext';

const HeaderPortal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, timeLeft, bioOk } = useAuth();
  const [warned, setWarned] = useState(false);

  // Estados de control de UI
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // Modal de Cierre Manual
  const [modalExpiraOpen, setModalExpiraOpen] = useState(false); // Modal de Advertencia (60s)
  const [modalCierreAutoOpen, setModalCierreAutoOpen] = useState(false); // Modal de Cierre Automático (0s)

  const isStarter = location.pathname.startsWith('/app/starter');
  const handleLogout = () => setModalOpen(true);

  const confirmLogout = () => {
    // Usa la función logout del contexto para hacer la limpieza completa
    logout();
    setIsAuthenticated(false);
    setModalOpen(false);
    navigate('/auth/login');
  };

  const cancelLogout = () => setModalOpen(false);
  
  // Función para cerrar el modal de cierre automático
  const closeModalCierreAuto = () => {
    setModalCierreAutoOpen(false);
  };

  // 1. Detección de sesión al cambiar de ruta
  useEffect(() => {
    const idSesion = localStorage.getItem('auth.idSesion');
    setIsAuthenticated(Boolean(idSesion && bioOk));
  }, [location.pathname, bioOk]);

  // 2) Modales: Advertencia 60s + Cierre autom.
  useEffect(() => {
    // A) Advertencia 60s: abre una sola vez cuando cruza el umbral, y se cierra al salir del umbral
    if (timeLeft !== null && timeLeft <= 60 && !modalExpiraOpen && !warned) {
      setModalExpiraOpen(true);
    }
    if ((timeLeft === null || timeLeft > 60) && modalExpiraOpen) {
      setModalExpiraOpen(false);
    }

    // B) Cierre automático (detecta flag del AuthContext)
    const auto = localStorage.getItem('auth.autoLoggedOut') === 'true';
    if (auto) {
      console.log('[HEADER DEBUG] Cierre automático detectado por flag.');
      setModalCierreAutoOpen(true);
      localStorage.removeItem('auth.autoLoggedOut'); // limpiar para no repetir
      navigate('/auth/login'); // redirige inmediatamente
    }
  }, [timeLeft, modalExpiraOpen, warned, navigate]);

  return (
    <div
      // Ajustamos la altura y padding con clases de Bootstrap
      className="bg-light border-bottom py-2 py-md-3 px-3 px-md-4 d-flex align-items-center"
      style={{ minHeight: '70px', height: 'auto', zIndex: 1030 }}
    >
      <Row className="align-items-center w-100 m-0">
        {/* Logo Columna */}
        <Col xs="6" className="d-flex align-items-center ps-0 ps-md-2">
          <img
            src={LogoIncoop}
            alt="Logo SG"
            // Tamaño del logo: h-auto con max-height responsivo
            className="img-fluid"
            style={{ 
                cursor: 'pointer',
                maxHeight: '40px', // Tamaño móvil
                minHeight: '30px', 
            }}
            onClick={() => navigate('/auth/login')}
          />
        </Col>

        {/* Botón cerrar sesión Columna */}
        <Col xs="6" className="d-flex justify-content-end align-items-center pe-0 pe-md-2">
          {isAuthenticated && isStarter && (
            <Button 
                color="secondary" 
                size="sm" // Botón pequeño, ideal para header en móvil
                onClick={handleLogout}
            >
              Cerrar sesión
            </Button>
          )}
        </Col>
      </Row>


      {/* Modal de confirmación (Cierre Manual) */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Confirmar Cierre de Sesión</ModalHeader>
        <ModalBody>¿Estás seguro de que quieres cerrar sesión?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={cancelLogout}>
            Cancelar
          </Button>
          <Button color="primary" onClick={confirmLogout}>
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>

      {/* ⏱ Modal de expiración automática (60s) */}
      <Modal isOpen={modalExpiraOpen} backdrop="static" keyboard={false}>
        <ModalHeader>⚠️ Sesión a punto de expirar</ModalHeader>
        <ModalBody>
          Tu sesión expirará automáticamente en menos de 1 minuto.
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              // El usuario ya fue advertido; no reabrir hasta nueva sesión
              setModalExpiraOpen(false);
              setWarned(true);
            }}
          >
            Entendido
          </Button>
        </ModalFooter>
      </Modal>

      {/*  Modal de Cierre de sesión automático (0s) */}
      <Modal isOpen={modalCierreAutoOpen} backdrop="static" keyboard={false}>
        <ModalHeader>Sesión Finalizada</ModalHeader>
        <ModalBody>
          <Alert color="danger">
            Su sesión de 5 minutos se cerró automáticamente debido al tiempo límite de uso.
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={closeModalCierreAuto}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default HeaderPortal;